import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import PageHeader from '../components/PageHeader';
import InstagramIcon from '@mui/icons-material/Instagram';
import etsyLogo from '../assets/etsy_logo.png';
import facebookLogo from '../assets/facebookLogo.png';
import * as emailjs from 'emailjs-com';

export default function SignUp() {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const firstName = data.get('firstName');
    const lastName = data.get('lastName');
    const message = data.get('message');
    const phoneNumber = data.get('phoneNumber');
    const email = data.get('email');
    const templateParams = {
      from_name: firstName + ' ' + lastName,
      from_email: email,
      message,
      phoneNumber,
    };
    emailjs.send(
      'service_aqwqfqf',
      'template_9a1s8ap',
      templateParams,
      'user_eA4SwTxRO6tlvA4TufCPY'
    );
  };

  const pageHeader = {
    title: `Contact`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };
  return (
    <Container disableGutters component='main' maxWidth='2xl' sx={{ mb: 10 }}>
      <CssBaseline />
      <PageHeader post={pageHeader} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignContent: 'center',
          justifyContent: 'space-around',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'space-around',
          }}
        >
          <a
            target='_blank'
            style={{ marginBottom: 50 }}
            href='https://www.instagram.com/sheyscraftroom/?hl=en'
          >
            <InstagramIcon sx={{ fontSize: 50 }} />
          </a>
          <a
            target='_blank'
            style={{ marginBottom: 50 }}
            href='https://www.facebook.com/SheysCraftRoom'
          >
            <img src={facebookLogo} width={100} />
          </a>
          <a
            target='_blank'
            style={{ marginBottom: 50 }}
            href='https://www.etsy.com/shop/SheysCraftRoom'
          >
            <img src={etsyLogo} width={100} />
          </a>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'space-around',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'space-around',
            }}
          >
            <Typography sx={{ fontSize: 40 }} component='h6' variant='primary'>
              Phone: 832.280.4855
            </Typography>
            <Typography sx={{ fontSize: 40 }} component='h6' variant='primary'>
              Email: shey@sheyscraftroom.com
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              component='form'
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 3 }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete='given-name'
                    name='firstName'
                    required
                    fullWidth
                    id='firstName'
                    label='First Name'
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    id='lastName'
                    label='Last Name'
                    name='lastName'
                    autoComplete='family-name'
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    id='email'
                    label='Email Address'
                    name='email'
                    autoComplete='email'
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id='phoneNumber'
                    label='Phone Number'
                    name='phoneNumber'
                    autoComplete='phone'
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    multiline
                    fullWidth
                    rows={6}
                    name='message'
                    label='Message'
                    type='message'
                    id='message'
                  />
                </Grid>
              </Grid>
              <Button
                type='submit'
                fullWidth
                variant='contained'
                sx={{ mt: 3, mb: 2 }}
              >
                Send Message
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'space-around',
            }}
          >
            <div class='elfsight-app-5b7d4589-9107-42d8-b91e-dbc5b227953e'></div>
            <div class='elfsight-app-1786f172-8488-494c-9462-26cc3af5ad4a'></div>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
